import { render, staticRenderFns } from "./kevi-alert.vue?vue&type=template&id=0f9e2627&scoped=true"
import script from "./kevi-alert.vue?vue&type=script&lang=js"
export * from "./kevi-alert.vue?vue&type=script&lang=js"
import style0 from "./kevi-alert.vue?vue&type=style&index=0&id=0f9e2627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e2627",
  null
  
)

export default component.exports